/**
 * Bundle Builder — Mobile-First Step Wizard
 * Horizontal carousel + bottom sheet + step navigation
 */
(function () {
  'use strict';

  document.querySelectorAll('.bundle-builder').forEach(init);

  function init(root) {
    var id = root.dataset.sectionId;
    var slotCount = parseInt(root.dataset.slotCount, 10);
    var discountLabel = root.dataset.discountLabel || '';
    var discountMatch = discountLabel.match(/-?(\d+)%/);
    var discountPercent = discountMatch ? parseInt(discountMatch[1], 10) : 15;

    var sheet = document.getElementById('bundle-sheet-' + id);
    var backdrop = document.getElementById('bundle-backdrop-' + id);
    var bar = document.getElementById('bundle-bar-' + id);
    var barCta = bar.querySelector('[data-action="next"]');

    var desktopMQ = window.matchMedia('(min-width: 768px)');
    var panelDetail = document.getElementById('bundle-panel-detail-' + id);
    var panelSummary = document.getElementById('bundle-panel-summary-' + id);

    var state = {
      currentStep: 1,
      selections: {},
      sheetSlot: null,
      sheetProductId: null,
      sheetVariantId: null,
      sheetPrice: null,
    };

    // Category/function filtering
    var enableCategory = root.dataset.enableCategory === 'true';
    var selectedFunction = null;

    // Read ?function= from URL and resolve handle to collection title
    var urlParams = new URLSearchParams(window.location.search);
    var urlFunction = urlParams.get('function');
    if (urlFunction) {
      // URL has handle (e.g. "grenadier-de-chars"), resolve to title (e.g. "Grenadier de chars")
      var matchingCard = root.querySelector('.bundle-category-card[data-function-handle="' + urlFunction + '"]');
      if (matchingCard && matchingCard.dataset.function) {
        urlFunction = matchingCard.dataset.function;
      }
    }

    // --- Helper: mark a card as selected and dim siblings ---
    function markCardSelected(carousel, card) {
      carousel.querySelectorAll('.bundle-card').forEach(function (c) {
        c.classList.remove('is-selected', 'is-dimmed');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      carousel.querySelectorAll('.bundle-card:not(.is-selected):not(.is-filtered)').forEach(function (c) {
        c.classList.add('is-dimmed');
      });
    }

    // --- Card click → desktop panel or mobile sheet ---
    root.querySelectorAll('.bundle-card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (desktopMQ.matches && panelDetail) { openDesktopPanel(card); }
        else { openSheet(card); }
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (desktopMQ.matches && panelDetail) { openDesktopPanel(card); }
          else { openSheet(card); }
        }
      });
    });

    // --- Back buttons ---
    root.querySelectorAll('.bundle-back-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var backTo = parseInt(btn.dataset.backTo, 10);
        goToStep(backTo);
      });
    });

    // --- Category picker (Step 0) ---
    root.querySelectorAll('.bundle-category-card').forEach(function (card) {
      card.addEventListener('click', function () {
        selectCategory(card.dataset.function, card.dataset.functionHandle);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCategory(card.dataset.function, card.dataset.functionHandle);
        }
      });
    });

    function selectCategory(functionName, functionHandle) {
      selectedFunction = functionName;
      applyFunctionFilter(functionName);

      // Update URL without reload
      var url = new URL(window.location);
      url.searchParams.set('function', functionHandle);
      history.replaceState(null, '', url);

      // Hide Step 0, show Step 1
      goToStep(1);

      // Auto-select slots with only 1 product
      autoSelectSingleProducts();
    }

    // --- Carousel scroll arrows ---
    root.querySelectorAll('.bundle-carousel-arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var slotNum = arrow.dataset.slot;
        var carousel = root.querySelector('.bundle-carousel[data-slot="' + slotNum + '"]');
        if (!carousel) return;
        var scrollAmount = carousel.offsetWidth * 0.7;
        if (arrow.dataset.dir === 'left') scrollAmount = -scrollAmount;
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });

    // Update arrow visibility on scroll
    root.querySelectorAll('.bundle-carousel').forEach(function (carousel) {
      function updateArrows() {
        var wrap = carousel.parentElement;
        var leftArr = wrap.querySelector('.bundle-carousel-arrow--left');
        var rightArr = wrap.querySelector('.bundle-carousel-arrow--right');
        if (!leftArr || !rightArr) return;
        leftArr.classList.toggle('is-hidden', carousel.scrollLeft < 10);
        rightArr.classList.toggle('is-hidden', carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 10);
      }
      carousel.addEventListener('scroll', updateArrows, { passive: true });
      // Initial check after a short delay (images may not be loaded yet)
      setTimeout(updateArrows, 500);
    });

    // --- Bottom sheet ---
    function openSheet(card) {
      var slot = card.dataset.slot;
      var variants = parseVariants(card);
      var available = variants.filter(function (v) { return v.available; });

      state.sheetSlot = slot;
      state.sheetProductId = card.dataset.productId;
      state.sheetVariantId = null;
      state.sheetPrice = parseInt(card.dataset.productPrice, 10);

      // Immediately mark card as selected
      var carousel = root.querySelector('.bundle-carousel[data-slot="' + slot + '"]');
      if (carousel) { markCardSelected(carousel, card); }

      // Populate sheet
      sheet.querySelector('.bundle-sheet__img').src = card.dataset.productImage || '';
      sheet.querySelector('.bundle-sheet__img').alt = card.dataset.productTitle || '';
      sheet.querySelector('.bundle-sheet__name').textContent = card.dataset.productTitle || '';
      sheet.querySelector('.bundle-sheet__price').textContent = formatMoney(state.sheetPrice);

      // Size pills
      var sizesEl = sheet.querySelector('.bundle-sheet__sizes');
      sizesEl.innerHTML = '';
      variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bundle-size-pill';
        btn.textContent = v.title;
        btn.dataset.variantId = v.id;
        btn.dataset.price = v.price;
        if (!v.available) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
        btn.addEventListener('click', function () { selectSize(btn); });
        sizesEl.appendChild(btn);
      });

      // Auto-select if single available variant
      var confirmBtn = sheet.querySelector('.bundle-sheet__confirm');
      confirmBtn.disabled = true;
      if (available.length === 1) {
        var singleBtn = sizesEl.querySelector('[data-variant-id="' + available[0].id + '"]');
        if (singleBtn) selectSize(singleBtn);
      }

      // Open
      sheet.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function selectSize(btn) {
      var sizesEl = btn.parentElement;
      sizesEl.querySelectorAll('.bundle-size-pill').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      state.sheetVariantId = btn.dataset.variantId;
      state.sheetPrice = parseInt(btn.dataset.price, 10);

      sheet.querySelector('.bundle-sheet__confirm').disabled = false;
    }

    sheet.querySelector('.bundle-sheet__confirm').addEventListener('click', function () {
      if (!state.sheetVariantId) return;
      confirmSelection();
    });

    function confirmSelection() {
      var slot = state.sheetSlot;
      var activeBtn = sheet.querySelector('.bundle-size-pill.is-active');

      state.selections[slot] = {
        productId: state.sheetProductId,
        variantId: state.sheetVariantId,
        price: state.sheetPrice,
        title: sheet.querySelector('.bundle-sheet__name').textContent,
        image: sheet.querySelector('.bundle-sheet__img').src,
        size: activeBtn ? activeBtn.textContent : '',
      };

      // Mark card as selected
      var carousel = root.querySelector('.bundle-carousel[data-slot="' + slot + '"]');
      if (carousel) {
        var selected = carousel.querySelector('[data-product-id="' + state.sheetProductId + '"]');
        if (selected) { markCardSelected(carousel, selected); }
      }

      closeSheet();
      updateBar();
      updateDots();

      // Auto-advance to next step after short delay
      var nextStep = parseInt(slot) + 1;
      if (nextStep <= slotCount) {
        setTimeout(function () { goToStep(nextStep); }, 350);
      } else {
        // All done, show review
        setTimeout(function () { showReview(); }, 350);
      }
    }

    // --- Desktop panel ---
    function openDesktopPanel(card) {
      var slot = card.dataset.slot;
      var variants = parseVariants(card);
      var available = variants.filter(function (v) { return v.available; });

      state.sheetSlot = slot;
      state.sheetProductId = card.dataset.productId;
      state.sheetVariantId = null;
      state.sheetPrice = parseInt(card.dataset.productPrice, 10);

      // Immediately mark card as selected
      var carousel = root.querySelector('.bundle-carousel[data-slot="' + slot + '"]');
      if (carousel) { markCardSelected(carousel, card); }

      panelDetail.querySelector('.bundle-panel-detail__img').src = card.dataset.productImage || '';
      panelDetail.querySelector('.bundle-panel-detail__img').alt = card.dataset.productTitle || '';
      panelDetail.querySelector('.bundle-panel-detail__name').textContent = card.dataset.productTitle || '';
      panelDetail.querySelector('.bundle-panel-detail__price').textContent = formatMoney(state.sheetPrice);

      var sizesEl = panelDetail.querySelector('.bundle-panel-detail__sizes');
      sizesEl.innerHTML = '';
      variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bundle-size-pill';
        btn.textContent = v.title;
        btn.dataset.variantId = v.id;
        btn.dataset.price = v.price;
        if (!v.available) { btn.disabled = true; }
        btn.addEventListener('click', function () {
          sizesEl.querySelectorAll('.bundle-size-pill').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.sheetVariantId = btn.dataset.variantId;
          state.sheetPrice = parseInt(btn.dataset.price, 10);
          panelDetail.querySelector('.bundle-panel-detail__confirm').disabled = false;
        });
        sizesEl.appendChild(btn);
      });

      var confirmBtn = panelDetail.querySelector('.bundle-panel-detail__confirm');
      confirmBtn.disabled = true;
      if (available.length === 1) {
        var singleBtn = sizesEl.querySelector('[data-variant-id="' + available[0].id + '"]');
        if (singleBtn) { singleBtn.click(); }
      }

      bar.classList.remove('is-summary-mode');
      bar.classList.add('is-detail-mode');
      bar.scrollTop = 0;
    }

    function closeDesktopPanel() {
      bar.classList.remove('is-detail-mode');
      bar.classList.add('is-summary-mode');
    }

    function confirmDesktop() {
      var slot = state.sheetSlot;
      var activeBtn = panelDetail.querySelector('.bundle-size-pill.is-active');

      state.selections[slot] = {
        productId: state.sheetProductId,
        variantId: state.sheetVariantId,
        price: state.sheetPrice,
        title: panelDetail.querySelector('.bundle-panel-detail__name').textContent,
        image: panelDetail.querySelector('.bundle-panel-detail__img').src,
        size: activeBtn ? activeBtn.textContent : '',
      };

      var carousel = root.querySelector('.bundle-carousel[data-slot="' + slot + '"]');
      if (carousel) {
        var selected = carousel.querySelector('[data-product-id="' + state.sheetProductId + '"]');
        if (selected) { markCardSelected(carousel, selected); }
      }

      closeDesktopPanel();
      updateBar();
      updateDots();

      var nextStep = parseInt(slot) + 1;
      if (nextStep <= slotCount) {
        setTimeout(function () { goToStep(nextStep); }, 350);
      } else {
        setTimeout(function () { showReview(); }, 350);
      }
    }

    if (panelDetail) {
      panelDetail.querySelector('.bundle-panel-detail__confirm').addEventListener('click', function () {
        if (!state.sheetVariantId) return;
        confirmDesktop();
      });
      panelDetail.querySelector('.bundle-panel-detail__back').addEventListener('click', closeDesktopPanel);

      // Revert panel on resize to mobile
      desktopMQ.addEventListener('change', function (e) {
        if (!e.matches && bar.classList.contains('is-detail-mode')) { closeDesktopPanel(); }
      });
    }

    // --- Function filtering ---
    function applyFunctionFilter(functionName) {
      if (!functionName) return;
      var functionLower = functionName.trim().toLowerCase();

      root.querySelectorAll('.bundle-card').forEach(function (card) {
        var tags = (card.dataset.functionTags || '').split(',').map(function(t) { return t.trim().toLowerCase(); }).filter(Boolean);
        var hasFonction = card.dataset.hasFonction === 'true';

        // A product is "generic" only if it has no fonction tag AND no matched troop tags
        var isGeneric = !hasFonction && tags.length === 0;

        // A product matches if any tag matches the selected function
        var matches = tags.some(function(t) { return t === functionLower; });

        if (matches || isGeneric) {
          card.classList.remove('is-filtered');
          card.dataset.isGeneric = isGeneric ? '1' : '0';
        } else {
          card.classList.add('is-filtered');
        }
      });

      // Sort visible products: troop-specific first, then generic
      for (var i = 1; i <= slotCount; i++) {
        var carousel = root.querySelector('.bundle-carousel[data-slot="' + i + '"]');
        if (!carousel) continue;
        var cards = Array.prototype.slice.call(carousel.querySelectorAll('.bundle-card'));
        var visible = cards.filter(function(c) { return !c.classList.contains('is-filtered'); });
        var troopCards = visible.filter(function(c) { return c.dataset.isGeneric !== '1'; });
        var genericCards = visible.filter(function(c) { return c.dataset.isGeneric === '1'; });
        troopCards.concat(genericCards).forEach(function(c) { carousel.appendChild(c); });
      }
    }

    // --- Auto-select single visible product per slot ---
    function autoSelectSingleProducts() {
      for (var i = 1; i <= slotCount; i++) {
        var carousel = root.querySelector('.bundle-carousel[data-slot="' + i + '"]');
        if (!carousel) continue;
        var visibleCards = Array.prototype.filter.call(
          carousel.querySelectorAll('.bundle-card'),
          function (c) { return !c.classList.contains('is-filtered'); }
        );
        if (visibleCards.length !== 1) continue;

        var card = visibleCards[0];
        var variants = parseVariants(card);
        var available = variants.filter(function (v) { return v.available; });
        if (available.length === 0) continue;

        // Pick first available variant
        var variant = available[0];
        state.selections[String(i)] = {
          productId: card.dataset.productId,
          variantId: variant.id,
          price: variant.price,
          title: card.dataset.productTitle || '',
          image: card.dataset.productImage || '',
          size: variant.title || '',
        };

        // Visual feedback
        markCardSelected(carousel, card);
      }

      updateBar();
      updateDots();

      // Auto-advance to first unselected step
      for (var j = 1; j <= slotCount; j++) {
        if (!state.selections[String(j)]) {
          goToStep(j);
          return;
        }
      }
      // All slots filled — show review
      showReview();
    }

    function closeSheet() {
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    backdrop.addEventListener('click', closeSheet);

    // Swipe down to close sheet
    var sheetTouchStartY = 0;
    sheet.addEventListener('touchstart', function (e) {
      sheetTouchStartY = e.touches[0].clientY;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      var dy = e.touches[0].clientY - sheetTouchStartY;
      if (dy > 80 && sheet.scrollTop <= 0) { closeSheet(); }
    }, { passive: true });

    // --- Step navigation ---
    function goToStep(step) {
      state.currentStep = step;
      root.querySelectorAll('.bundle-step').forEach(function (s) {
        s.classList.remove('is-active');
      });
      root.querySelector('.bundle-review').classList.remove('is-active');

      var target = root.querySelector('[data-step="' + step + '"]');
      if (target) target.classList.add('is-active');

      updateDots();
      updateBarCta();

      // Scroll to top of builder
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function showReview() {
      state.currentStep = slotCount + 1;
      root.querySelectorAll('.bundle-step').forEach(function (s) {
        s.classList.remove('is-active');
      });

      var review = root.querySelector('.bundle-review');
      var grid = review.querySelector('.bundle-review__grid');
      grid.innerHTML = '';

      var total = 0;
      for (var i = 1; i <= slotCount; i++) {
        var sel = state.selections[i];
        if (!sel) continue;
        total += sel.price;

        var card = document.createElement('div');
        card.className = 'bundle-review__card';
        card.innerHTML = '<img class="bundle-review__img" src="' + sel.image + '" alt="' + escapeHtml(sel.title) + '">' +
          '<div class="bundle-review__body">' +
            '<div class="bundle-review__name">' + escapeHtml(sel.title) + '</div>' +
            '<div class="bundle-review__size">' + escapeHtml(sel.size) + '</div>' +
            '<div class="bundle-review__edit">&#9998; Edit</div>' +
          '</div>';

        // Tap to go back to that step
        (function (step) {
          card.style.cursor = 'pointer';
          card.addEventListener('click', function () { goToStep(step); });
        })(i);

        grid.appendChild(card);
      }

      var discounted = total * (1 - discountPercent / 100);
      review.querySelector('.bundle-review__original').textContent = formatMoney(total);
      review.querySelector('.bundle-review__final').textContent = formatMoney(discounted);
      review.querySelector('.bundle-review__savings').textContent = '-' + formatMoney(total - discounted);

      review.classList.add('is-active');
      updateDots();
      updateBarCta();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // --- Bar CTA ---
    barCta.addEventListener('click', function () {
      if (state.currentStep === 0) return; // Must pick a category first

      var allDone = Object.keys(state.selections).length === slotCount;

      if (state.currentStep <= slotCount && !allDone) {
        // Advance to next incomplete step
        var next = state.currentStep;
        for (var i = 1; i <= slotCount; i++) {
          if (!state.selections[i]) { next = i; break; }
        }
        if (next === state.currentStep && state.selections[state.currentStep]) {
          next = state.currentStep < slotCount ? state.currentStep + 1 : slotCount;
        }
        goToStep(next);
      } else if (allDone && state.currentStep !== slotCount + 1) {
        showReview();
      } else if (allDone) {
        addToCart();
      }
    });

    function updateBarCta() {
      var allDone = Object.keys(state.selections).length === slotCount;
      if (allDone && state.currentStep === slotCount + 1) {
        barCta.textContent = barCta.dataset.labelCart || 'Add to Cart';
        barCta.dataset.action = 'cart';
      } else if (allDone) {
        barCta.textContent = barCta.dataset.labelReview || 'Review Pack';
        barCta.dataset.action = 'review';
      } else {
        barCta.textContent = barCta.dataset.labelNext || 'Next →';
        barCta.dataset.action = 'next';
      }
    }

    // --- Update bar thumbnails + pricing ---
    function updateBar() {
      var total = 0;
      var count = 0;
      for (var i = 1; i <= slotCount; i++) {
        var thumb = bar.querySelector('[data-bar-thumb="' + i + '"]');
        if (state.selections[i]) {
          count++;
          total += state.selections[i].price;
          thumb.innerHTML = '<img src="' + state.selections[i].image + '" style="width:100%;height:100%;object-fit:cover;" alt="' + escapeHtml(state.selections[i].title) + '">';
          thumb.style.borderColor = 'rgb(var(--bundle-accent))';
          thumb.title = state.selections[i].title + ' (' + state.selections[i].size + ')';
          // Update step status text
          var statusEl = bar.querySelector('[data-bar-status="' + i + '"]');
          if (statusEl) {
            statusEl.textContent = state.selections[i].title.substring(0, 25) + ' · ' + state.selections[i].size;
            statusEl.style.color = 'rgb(var(--bundle-accent))';
          }
        }
      }

      var priceEl = bar.querySelector('.bundle-bar__price');
      var savingsEl = bar.querySelector('.bundle-bar__savings');
      if (count > 0) {
        var discounted = total * (1 - discountPercent / 100);
        priceEl.textContent = count === slotCount ? formatMoney(discounted) : formatMoney(total);
        if (count === slotCount) {
          savingsEl.textContent = '-' + formatMoney(total - discounted);
        } else {
          savingsEl.textContent = '';
        }
      }
    }

    // --- Update progress dots ---
    function updateDots() {
      root.querySelectorAll('.bundle-dot').forEach(function (dot) {
        var idx = parseInt(dot.dataset.dot);
        dot.classList.remove('is-done', 'is-current');
        if (state.selections[idx]) {
          dot.classList.add('is-done');
        } else if (idx === state.currentStep) {
          dot.classList.add('is-current');
        }
      });

      // Mark step 0 dot as done if category is selected
      var dot0 = root.querySelector('[data-dot="0"]');
      if (dot0) {
        dot0.classList.remove('is-done', 'is-current');
        if (selectedFunction) {
          dot0.classList.add('is-done');
        } else if (state.currentStep === 0) {
          dot0.classList.add('is-current');
        }
      }
    }

    // --- Add to cart ---
    function addToCart() {
      var items = [];
      for (var i = 1; i <= slotCount; i++) {
        if (state.selections[i]) {
          items.push({ id: parseInt(state.selections[i].variantId, 10), quantity: 1 });
        }
      }
      if (items.length !== slotCount) return;

      barCta.disabled = true;
      var origText = barCta.textContent;
      barCta.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
        .then(function () {
          barCta.textContent = '\u2713';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function () {
          barCta.textContent = origText;
          barCta.disabled = false;
        });
    }

    // --- Init ---
    updateBarCta();

    // --- Category/function initialization ---
    if (urlFunction) {
      // Mode 1: function pre-selected via URL
      selectedFunction = urlFunction;
      applyFunctionFilter(selectedFunction);
      // Skip Step 0, activate Step 1
      var step0 = root.querySelector('[data-step="0"]');
      if (step0) step0.classList.remove('is-active');
      var step1 = root.querySelector('[data-step="1"]');
      if (step1) step1.classList.add('is-active');
      state.currentStep = 1;
      updateDots();
      updateBarCta();
      autoSelectSingleProducts();
    } else if (enableCategory) {
      // Mode 2: show category picker (Step 0)
      state.currentStep = 0;
      updateDots();
      updateBarCta();
    } else if (root.dataset.presetFunction) {
      // Mode 3: category picker disabled with preset function
      selectedFunction = root.dataset.presetFunction;
      applyFunctionFilter(selectedFunction);
      autoSelectSingleProducts();
    }
  }

  function escapeHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  var SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL'];

  function parseVariants(card) {
    var ids = (card.dataset.variants || '').split(',');
    var titles = (card.dataset.variantTitles || '').split('|||');
    var prices = (card.dataset.variantPrices || '').split(',');
    var avails = (card.dataset.variantAvailable || '').split(',');
    var result = [];
    for (var i = 0; i < ids.length; i++) {
      if (!ids[i]) continue;
      result.push({
        id: ids[i].trim(),
        title: (titles[i] || '').trim(),
        price: parseInt(prices[i], 10) || 0,
        available: avails[i] && avails[i].trim() === 'true',
      });
    }
    result.sort(function (a, b) {
      var ai = SIZE_ORDER.indexOf(a.title.toUpperCase());
      var bi = SIZE_ORDER.indexOf(b.title.toUpperCase());
      if (ai === -1) ai = 999;
      if (bi === -1) bi = 999;
      return ai - bi;
    });
    return result;
  }

  function formatMoney(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }
})();
